import AddressTypes from './views/AddressTypes';
import AddressType from './views/AddressType';

export default {
  routes: [
    {
      path: '/address/types',
      name: 'AddressTypes',
      component: AddressTypes,
      meta: {tab: 'address-types', setting_link: 'DealsStatuses'}
    },
    {
      path: '/address/types/:type_id/edit',
      name: 'AddressType',
      components: { default: AddressTypes, right: AddressType },
      meta: {tab: 'address-types', setting_link: 'DealsStatuses'}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/modules/address/routes.js